import React from "react";

const ServiceModal = ({ id, title, description, icon }) => {
  return (
    <div
      className="modal fade iran-sans"
      id={id}
      tabIndex="-1"
      aria-labelledby={`${id}-label`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-center">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title fw-bold" id={`${id}-label`}>
              {title}
            </h5>
            <button
              type="button"
              className="btn-close position-absolute end-0 me-3"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              {icon ? (
                <div className="col justify-content-center d-flex">
                  <img
                    className="mb-4"
                    src={icon}
                    alt=""
                    style={{
                      width: "80px",
                      height: "80px",
                      marginBottom: "15px",
                    }}
                  />
                </div>
              ) : null}
            </div>
            <div className="row">
              <p className="text-muted">{description}</p>
            </div>
          </div>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn-clear fw-bold fw-semibold"
              data-bs-dismiss="modal"
            >
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;
